import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const ProfileHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 356px;
    width: 80%;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 2rem;
    min-height: calc(100% - 76px);
    background-color: ${({ theme }) => theme.newBg1}; //#393941;
    border-radius: 0.5rem 0.5rem 0 0;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    `}
`;

export const HeaderBottom = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 76px;
    background-color: ${({ theme }) => theme.newBg2};
    border-radius: 0 0 0.5rem 0.5rem;
`;

export const HeaderBottomTabItem = styled.span`
    height: 100%;
    line-height: 76px;
    position:relative;
    overflow: hidden;
    cursor: pointer;
    padding: 0 1rem;
    flex: 1;
    text-align: center;
    &:not(.active) {
        &:hover {
            cursor: pointer;
            &::after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                height: 20px;
                width: 20px;
                transform: rotate(45deg);
                background-color: ${({ theme }) => theme.yetiBlue};
                margin: 0 -10px;
            }
        }
    }
   
    &.active {
        &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            height: 20px;
            width: 20px;
            transform: rotate(45deg);
            background-color: ${({ theme }) => theme.yetiBlue};
            margin: 0 -10px;
        }
    }
`;

export const HeaderProfileImage = styled.div`
    height: 150px;
    width: 150px;
    z-index: 1;
    background-color: ${({ theme }) => theme.newBg2};
    border-radius: 50%;
    margin-right: 1rem;
    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

export const HeaderUserInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 80%;
    color: #fff;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
        font-size: 0.8rem;
    `}

`;

export const UserTitle = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 1rem 0;
    width: 100%;
    display: flex;
    align-items: center;
    svg {
        width: 1.5rem;
        margin-right: 0.5rem;
        fill: rgb(32, 129, 226);
    }
`

export const HeaderSocial = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 1rem;
    height: 100%;
`;

export const HeaderSocialItem = styled.a`
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 10px;
    margin-right: 10px;
    background-color: #fff;
    color: #393941;
    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        transform: translateY(-5px);
        transition: all 0.3s ease-in-out;
        cursor: pointer;
    }
`;

export const HeaderSocialItemNavLink = styled(NavLink)`
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    //width: 2rem;
    height: 2rem;
    border-radius: 10px;
    margin: 5px;
    margin-right: 10px;
    background-color: #fff;
    color: #393941;
    font-size: 1rem;
    font-weight: normal;
    padding: 0 0.5rem;
    
    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        box-shadow-color: #fff;
        cursor: pointer;
        transform: scale(1.01);
        transition: all 0.1s ease-in-out;
    }
`;